// VFX: iPhone App Mockup
// Category: ui-elements  ·  Tags: iphone, mockup, app, phone, device
// Realistic iPhone frame with an app screen sliding in.
import {
  AbsoluteFill,
  useCurrentFrame,
  useVideoConfig,
  spring,
  interpolate,
} from "remotion";
import React from "react";

const clamp = {
  extrapolateLeft: "clamp",
  extrapolateRight: "clamp",
} as const;

export default function CardIphoneMockupAppReveal1000Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const phoneIn = spring({
    frame,
    fps,
    config: { damping: 18, stiffness: 90 },
  });
  const screenIn = spring({
    frame: frame - 12,
    fps,
    config: { damping: 22, stiffness: 110 },
  });
  const yOffset = interpolate(phoneIn, [0, 1], [80, 0], clamp);
  const screenY = interpolate(screenIn, [0, 1], [100, 0], clamp);

  return (
    <AbsoluteFill
      style={{
        background:
          "linear-gradient(135deg, #1e293b 0%, #0a0e1a 100%)",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          position: "relative",
          width: 540,
          height: 1100,
          borderRadius: 70,
          background: "#0a0a0a",
          padding: 16,
          boxShadow:
            "0 60px 160px rgba(0,0,0,0.7), 0 0 0 2px #2a2a2a, inset 0 0 0 4px #1a1a1a",
          transform: `translateY(${yOffset}px)`,
          opacity: phoneIn,
        }}
      >
        {/* screen */}
        <div
          style={{
            width: "100%",
            height: "100%",
            borderRadius: 58,
            background: "#0f172a",
            overflow: "hidden",
            position: "relative",
          }}
        >
          {/* notch */}
          <div
            style={{
              position: "absolute",
              top: 18,
              left: "50%",
              transform: "translateX(-50%)",
              width: 140,
              height: 36,
              background: "#000",
              borderRadius: 18,
              zIndex: 2,
            }}
          />
          {/* app content sliding in */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              padding: "100px 32px 32px",
              transform: `translateY(${screenY}%)`,
              opacity: screenIn,
              background:
                "linear-gradient(180deg, #a855f7 0%, #06b6d4 100%)",
            }}
          >
            <div
              style={{
                color: "#fff",
                fontSize: 44,
                fontWeight: 800,
                letterSpacing: "-1px",
                fontFamily: "system-ui, sans-serif",
              }}
            >
              Dimus
            </div>
            <div
              style={{
                color: "rgba(255,255,255,0.85)",
                fontSize: 22,
                marginTop: 8,
                fontFamily: "system-ui, sans-serif",
              }}
            >
              Your AI workspace
            </div>
            <div style={{ marginTop: 40, display: "flex", flexDirection: "column", gap: 16 }}>
              {[0, 1, 2, 3].map((i) => (
                <div
                  key={i}
                  style={{
                    height: 88,
                    background: "rgba(255,255,255,0.18)",
                    borderRadius: 16,
                    backdropFilter: "blur(8px)",
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
